import { ElementType } from "react";
import CommunicationIcon from "../assets/icons/CommunicationIcon";
import CompanyProfileIcon from "../assets/icons/sidebar/CompanyProfileIcon";
import DashboardIcon from "../assets/icons/sidebar/DashboardIcon";
import ProductManagementIcon from "../assets/icons/sidebar/ProductManagementIcon";
import ReportIcon from "../assets/icons/sidebar/ReportIcon";
import TicketManagementIcon from "../assets/icons/sidebar/TicketManagementIcon";
import { Role } from "../types/common";

interface MenuType {
  name: string;
  path: string;
  icon?: ElementType;
  badge?: string;
  role: Role[];
}

interface MenuTypes extends MenuType {
  children?: MenuType[];
}

const AllSidebarMenu: MenuTypes[] = [
  // Dashboard Menu
  {
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: DashboardIcon,
    role: ["super_admin", "Admin"],
  },
  {
    name: "Dashboard",
    path: "/user/dashboard",
    icon: DashboardIcon,
    role: ["User"],
  },

  // Communication Menu (Admin)
  {
    name: "Communication",
    path: "/admin/communication",
    icon: CommunicationIcon,
    role: ["super_admin"],
    children: [
      {
        name: "Message",
        path: "/admin/communication/message",
        role: ["super_admin"],
      },
      {
        name: "E-mail",
        path: "/admin/communication/email",
        role: ["super_admin"],
      },
    ],
  },

  // Communication Menu (Company)
  {
    name: "Communication",
    path: "/admin/communication",
    icon: CommunicationIcon,
    role: ["Admin"],
    children: [
      {
        name: "Message",
        path: "/admin/communication/message",
        role: ["Admin"],
      },
      {
        name: "E-mail",
        path: "/admin/communication/email",
        role: ["Admin"],
      },
    ],
  },

  // Communication Menu (User)
  {
    name: "Communication",
    path: "/user/communication",
    icon: CommunicationIcon,
    role: ["User"],
    children: [
      {
        name: "Message",
        path: "/user/communication/message",
        role: ["User"],
      },
      {
        name: "E-mail",
        path: "/user/communication/email",
        role: ["User"],
      },
    ],
  },

  // Ticket Management Menu (Admin)
  {
    name: "Ticket Management",
    path: "/admin/ticket-management",
    icon: TicketManagementIcon,
    role: ["super_admin"],
    children: [
      {
        name: "All Templates",
        path: "/admin/ticket-management/all-templates",
        role: ["super_admin"],
      },
      {
        name: "All Tickets",
        path: "/admin/ticket-management/all-tickets",
        role: ["super_admin"],
      },
      {
        name: "Assign to Me",
        path: "/admin/ticket-management/approval-hub",
        role: ["super_admin"],
      },
    ],
  },

  // Ticket Management Menu (User)
  {
    name: "Ticket Management",
    path: "/user/ticket-management",
    icon: TicketManagementIcon,
    role: ["super_admin", "Admin"],
    children: [
      {
        name: "All Templates",
        path: "/admin/ticket-management/all-templates",
        role: ["Admin"],
      },
      {
        name: "All Tickets",
        path: "/admin/ticket-management/all-tickets",
        role: ["super_admin", "Admin"],
      },
      {
        name: "Assign to me",
        path: "/admin/ticket-management/approval-hub",
        role: ["super_admin", "Admin"],
      },
    ],
  },
  {
    name: "Ticket Management",
    path: "/user/ticket-management",
    icon: TicketManagementIcon,
    role: ["User"],
    children: [
      {
        name: "All Tickets",
        path: "/user/ticket-management/all-tickets",
        role: ["User"],
      },
      {
        name: "Assign to me",
        path: "/user/ticket-management/approval-hub",
        role: ["User"],
      },
    ],
  },

  // Product Management Menu (Admin)
  {
    name: "Product Management",
    path: "/admin/product-management",
    icon: ProductManagementIcon,
    role: ["Admin", "super_admin"],
    children: [
      {
        name: "All Products",
        path: "/admin/product-management/all-products",
        role: ["Admin", "super_admin"],
      },
      {
        name: "All Features",
        path: "/admin/product-management/all-features",
        role: ["Admin", "super_admin"],
      },
    ],
  },

  // Company Profile Menu
  {
    name: "Company Profile",
    path: "/admin/company-profile",
    icon: CompanyProfileIcon,
    role: ["super_admin", "Admin"],
  },

  // Report Menu
  {
    name: "Reports",
    path: "/admin/reports",
    icon: ReportIcon,
    role: ["super_admin", "Admin", "User"],
  },
];

export default AllSidebarMenu;
